<ion-app>
	<ion-content [forceOverscroll]="false" class="background-black" *ngIf="splashLoading">
		<div class="d-flex ion-align-items-center h-100vh">
			<img [src]="splashImage | async" alt="">
		</div>
	</ion-content>
	<ion-router-outlet *ngIf="!splashLoading"></ion-router-outlet>
	<app-loading class="frame-stack-110000" [loading]="(loadingWithSpinner$ | async) ?? false"></app-loading>
</ion-app>
